<template>
    <v-container fluid>
        <v-snackbar
                v-model="snackbarError"
                :timeout="timeout"
                color="error"
                top
        >
            {{ snackbarErrorText }}
        </v-snackbar>
        <v-toolbar flat color="white">
            <v-toolbar-title>Обязательные документы </v-toolbar-title>
            <v-divider
                    class="mx-2"
                    inset
                    vertical
            >
            </v-divider>
            <v-spacer></v-spacer>
        </v-toolbar>

        <v-data-table
                :headers="headers"
                :items="documents"
                hide-actions
        >
            <template v-slot:items="props">
                <td>{{ documentsNames.find(x => x.id === props.item.documentName).name }}</td>
                <td>
                    <v-switch v-model="props.item.required" hide-details color="primary" @click.stop ="editDocument(props.item)"></v-switch>
                </td>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
    import axios from 'axios'
    export default{

        data(){
            return{
                token: null,
                backUrl: null,
                role: null,
                documents: [],
                documentsNames:[
                    {
                        id: 'procurementPlan',
                        name: 'Обоснование потребности в планируемой закупке и ее соответствие мероприятию соответствующей муниципальной программы: обоснования закупок товаров, работ и услуг для обеспечения государственных и муниципальных нужд при формировании и утверждении плана закупок'
                    },
                    {
                        id: 'procurementSchedule',
                        name: 'Обоснование потребности в планируемой закупке и ее соответствие мероприятию соответствующей муниципальной программы: обоснования закупок товаров, работ и услуг для обеспечения государственных и муниципальных нужд при формировании и утверждении плана-графика закупок'
                    },
                    {
                        id: 'technicalTask',
                        name: 'Техническое задание'
                    },
                    {
                        id: 'estimates',
                        name: 'Сметы'
                    },
                    {
                        id: 'defectiveStatements',
                        name: 'Дефектные ведомости'
                    },
                    {
                        id: 'projects',
                        name: 'Проекты'
                    },
                    {
                        id: 'sketches',
                        name: 'Эскизы'
                    },
                    {
                        id: 'performanceRequirements',
                        name: 'Требования к функциональным характеристикам (потребительским свойствам) товара (показатели, связанные с определением соответствия поставляемого товара, выполняемых работ, оказываемых услуг потребностям Заказчика) «Форма 2»'
                    },
                    {
                        id: 'targetedSubsidySubmission',
                        name: 'Соглашение на предоставление целевой субсидии'
                    },
                    {
                        id: 'priceInfo',
                        name: 'Ценовая информация, используемая для расчета начальной максимальной цены контракта, в том числе для расчета проектно-сметным методом и расчет с обоснованием начальной (максимальной) цены контракта (договора)'
                    },
                    {
                        id: 'infoForAdvancePayment',
                        name: 'Обоснование необходимости выплаты аванса (в случае, если Заказчиком принято решение о выплате аванса по контракту (договору)'
                    },
                    {
                        id: 'contractProject',
                        name: 'Проект контракта (договора) (в случае определения поставщика (подрядчика, исполнителя) по нескольким лотам - проект контракта (договора) в отношении каждого лота)'
                    },
                    {
                        id: 'contractProjectApplication',
                        name: 'Приложение к Проекту контракта (ПИК)'
                    },
                    {
                        id: 'evaluationRules',
                        name: 'Критерии и порядок оценки заявок на участие в конкурсе с указанием значимости каждого из критериев'
                    },
                    {
                        id: 'infoForStartContractPrice',
                        name: 'Обоснование начальной (максимальной) цены контракта'
                    },
                    {
                        id: 'startContractPriceCalc',
                        name: 'Расчет начальной (максимальной) цены контракта'
                    },
                    {
                        id: 'financingProof',
                        name: 'Подтверждение Финансирования / письмо ГРБС'
                    },
                    {
                        id: 'presenceInEIS',
                        name: 'Скан образ, подтверждающий наличие закупки в Плане-графике в ЕИС'
                    },
                    {
                        id: 'presenceInEASUZ',
                        name: 'Скан образ, подтверждающий наличие закупки в Плане-графике в ЕАСУЗ'
                    },
                    {
                        id: 'presenceInPIK',
                        name: 'Скан образ, подтверждающий наличие сформированной карточки в ПИК ЕАСУЗ'
                    },
                    {
                        id: 'letterToAddToCommission',
                        name: 'Письмо о включении в состав комиссии'
                    },
                    {
                        id: 'otherFiles',
                        name: 'Иные документы по усмотрению Заказчика, подтверждающие обоснованность и целесообразность планируемой закупки'
                    }
                ],
                headers: [
                    { text: 'Название документа', sortable: false, value: 'documentName'},
                    { text: 'Обязательность', sortable: false, value: 'required',width: '150'}
                ],
                snackbarError: false,
                timeout: 4000,
                snackbarErrorText: 'Произошла ошибка',
            }
        },

        created () {
            this.token = localStorage.getItem('token');
            this.role = localStorage.getItem('role');
            this.backUrl = localStorage.getItem('url');
            this.getDocuments()
        },

        methods:{
            getDocuments(){
                axios({
                    method: 'get',
                    url: this.backUrl + '/api/requiredDocuments',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(res => {
                    this.documents = res.data.data
                })
            },

            editDocument (item) {
                let confirmText = ''
                if(item.required){
                    confirmText = 'Снять обязательность с документа?'
                }else{
                    confirmText = 'Сделать документ обязательным?'
                }

                if(confirm(confirmText)){
                    axios({
                        method: 'put',
                        url: this.backUrl + '/api/requiredDocuments',
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                        data:{
                            id: item.id,
                            uuid: item.uuid,
                            required: !item.required,
                        }
                    }).then(() => {
                        this.getDocuments()
                    })
                    .catch( () => {
                        this.snackbarError = true
                    })
                }
            },
        }
    }
</script>
